export default __webpack_public_path__ + "static/media/addTestwhite.8a7e24c0.svg";